import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class ChatgptUtilityIESService extends BaseService {
  constructor() {
    super(constants.GET_CHATGPT_IES_USER_DATA, 'chatgptUtilityIESStatus');
  }

  async handleEvent(eventName, event) {
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders({});
      return this.getClient('aiadminstackb').post(`/chatutility/getuserdetails`, event.payload, {
        headers: enhancedHeaders
      });
    }
    // Default flow: aiadmin with automatic token handling
    return this.getClient('aiadmin').post(`/chatutility/getuserdetails`, event.payload);
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      Framework.getStoreRegistry().getStore('ChatgptUtilityIESUserData').setResponse(data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    // Framework.getStoreRegistry().getStore('chatgptUtility').resetStoreValues();
  }
}
